interface IReviewItemProps {
  rating: number
  title: string
  author: string
  authoredAt: string
  description: string
}

const ReviewItem: React.FC<IReviewItemProps> = ({
  rating,
  title,
  author,
  authoredAt,
  description
}) => {
  return (
    <section className="w-full flex flex-col items-start gap-2">
      <span className="text-yellow-500 mr-auto text-[23px] sm:text-[28px]">
        {'★'.repeat(rating)}
      </span>
      <h2 className="font-pretendard-bold text-[14px] sm:text-[18px] leading-[26px] sm:leading-[32px] text-left font-semibold text-main-light-1 dark:text-main-dark-1">
        {title}
      </h2>
      <div className="w-full flex justify-between">
        <span className="font-pretendard-bold text-main-light-2 dark:text-main-dark-2 text-[11px] sm:text-[13px] leading-[16px]">
          {author}
        </span>
        <span className="text-main-light-4 dark:text-main-dark-4 text-[11px] sm:text-[13px] leading-[16px]">
          {authoredAt}
        </span>
      </div>
      <p className="text-main-light-2 dark:text-main-dark-2 mt-4 text-left text-[13px] sm:text-[16px] leading-[21px] sm:leading-[27px] break-words">
        {description}
      </p>
    </section>
  )
}

export default ReviewItem
